import {
    deserialisePeople,
    Person
} from '@api/lendingAPI/CustomerStateAPIHelper';
import { fetchGetStateByStateKey } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../../iwQueryClient/useStateKey';

export function useGetShareholdersData(): Person[] {
    const stateKey = useStateKey();

    const { data } = useQuery({
        queryKey: ['customer_state', stateKey],
        queryFn: () => fetchGetStateByStateKey({ stateKey }),
        select: (response) => {
            if (!response?.data?.application?.people) {
                throw new Error('Application people data is required');
            }
            return deserialisePeople(response.data.application.people);
        }
    });

    return data ?? [];
}
